import { useQuery } from 'react-query';
import { Session } from '@utils/types/editors/sessions.ts';
import { Axios } from '@utils/api/axios-instance.ts';
import { GET_URL } from '@utils/api/endpoints.ts';
import { BaseError, BaseResponse } from '@utils/types/shared/base.ts';
import { AxiosError } from 'axios';

async function getSharedSession(
  id?: string,
  token?: string
): Promise<BaseResponse<Session>> {
  const { data } = await Axios.get(GET_URL(id).sharedSession, {
    params: { token }
  });
  return data;
}

const POLLING_INTERVAL_MS = 30_000;

function isWarming(session?: Session): boolean {
  if (!session) return false;
  const tier = session.access_tier ?? 'hot';
  if (tier === 'cold') return true;
  if (tier === 'archive' && !!session.archive_status) return true;
  return false;
}

export function useGetSharedTranscriptSession(id?: string, token?: string) {
  return useQuery<BaseResponse<Session>, AxiosError<BaseError>>(
    ['transcript-editor-shared-session', id],
    () => getSharedSession(id, token),
    {
      enabled: !!id && !!token,
      staleTime: Infinity,
      cacheTime: 1000 * 60 * 10,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      refetchInterval: data =>
        isWarming(data?.result) ? POLLING_INTERVAL_MS : false
    }
  );
}
